import CampanaNotificaciones from "./CampanaNotificaciones";
import BotonInstructivo from "./BotonInstructivo";
import BotonMapaProceso from "./BotonMapaProceso";
import { useState, useEffect } from "react";
import { subirDatos, eliminarDato } from "./syncSupabase";

const Q = {
  azul:"#1C3FAA", azulVivo:"#2A7FFF", azulMedio:"#6B6FD6",
  grisClaro:"#E8E9F6", grisPalido:"#F4F6FB", grisOscuro:"#2B2F36",
  grisPlata:"#8E93A1", blanco:"#FFFFFF",
};

const estadosCap = {
  programada: {label:"📅 Programada", color:"#3b82f6"},
  realizada:  {label:"✅ Realizada",  color:"#22c55e"},
  cancelada:  {label:"⛔ Cancelada",  color:"#e63946"},
  pendiente:  {label:"⏳ Pendiente",  color:"#f59e0b"},
};

const tiposCap = ["Inducción","ISO 9001","ISO 14001","ISO 45001","FSC","BPM","Seguridad e Higiene","Calidad en proceso","Uso de equipos","Procedimientos internos","Ciberseguridad","Otra"];
const modalidades = ["Presencial","Virtual","Híbrida","E-learning","En planta","Video grabado"];

function fechaHoy() { return new Date().toISOString().slice(0,10); }
function generarCodCap(lista) { return `CAP-${new Date().getFullYear()}-${String(lista.length+1).padStart(3,"0")}`; }

// ─── EXTRAER ID DE YOUTUBE / VIMEO ────────────────────────────
function extraerVideoId(url) {
  if (!url) return null;
  // YouTube
  const ytMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/);
  if (ytMatch) return { tipo:"youtube", id:ytMatch[1] };
  // Vimeo
  const viMatch = url.match(/vimeo\.com\/(\d+)/);
  if (viMatch) return { tipo:"vimeo", id:viMatch[1] };
  return { tipo:"otro", url };
}

function PlayerVideo({ url }) {
  const video = extraerVideoId(url);
  if (!video) return <p style={{ fontSize:"12px", color:"#e63946" }}>URL no válida</p>;

  if (video.tipo === "youtube") return (
    <div style={{ position:"relative", paddingBottom:"56.25%", height:0, borderRadius:"10px", overflow:"hidden" }}>
      <iframe
        src={`https://www.youtube.com/embed/${video.id}?rel=0&modestbranding=1`}
        style={{ position:"absolute", top:0, left:0, width:"100%", height:"100%", border:"none" }}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen title="Capacitación ALQOS™"/>
    </div>
  );

  if (video.tipo === "vimeo") return (
    <div style={{ position:"relative", paddingBottom:"56.25%", height:0, borderRadius:"10px", overflow:"hidden" }}>
      <iframe
        src={`https://player.vimeo.com/video/${video.id}`}
        style={{ position:"absolute", top:0, left:0, width:"100%", height:"100%", border:"none" }}
        allow="autoplay; fullscreen; picture-in-picture" allowFullScreen title="Capacitación ALQOS™"/>
    </div>
  );

  return (
    <a href={video.url} target="_blank" rel="noreferrer"
      style={{ display:"flex", alignItems:"center", gap:"8px", padding:"10px 14px", background:`${Q.azulVivo}12`, border:`1px solid ${Q.azulVivo}30`, borderRadius:"10px", color:Q.azulVivo, fontSize:"13px", fontWeight:"600", textDecoration:"none" }}>
      ▶ Ver video externo
    </a>
  );
}

export default function Capacitaciones({ onVolver, oscuro, usuario }) {
  const [caps, setCaps] = useState([]);
const [cargandoCaps, setCargandoCaps] = useState(true);
useEffect(() => {
  async function cargar() {
    try {
      const { supabase } = await import('./supabase');
      const { data } = await supabase.from('capacitaciones').select('data');
      if (data && data.length > 0) setCaps(data.map(r => r.data));
      else setCaps(JSON.parse(localStorage.getItem('alqos_caps')||'[]'));
    } catch(e) { setCaps(JSON.parse(localStorage.getItem('alqos_caps')||'[]')); }
    setCargandoCaps(false);
  }
  cargar();
}, []);
  const [vista, setVista]           = useState("listado");
  const [form, setForm]             = useState({ estado:"programada", tipo:"ISO 9001", modalidad:"Presencial", fecha:fechaHoy() });
  const [detalle, setDetalle]       = useState(null);
  const [confirmEliminar, setConfirmEliminar] = useState(null);
  const [nuevoAsistente, setNuevoAsistente] = useState("");
  const [filtroEstado, setFiltroEstado] = useState("todos");
  const [vistaVideos, setVistaVideos] = useState(false);
  const [asistentesForm, setAsistentesForm] = useState([]);
  const [inputAsistente, setInputAsistente] = useState("");
  const [sugerencias, setSugerencias] = useState([]);
  const [videoActivo, setVideoActivo] = useState(null);

  const nomina = (() => { try { return JSON.parse(localStorage.getItem('alqos_rrhh')||'[]'); } catch { return []; } })();

  const buscarSugerencias = (texto) => {
    if (!texto.trim()) { setSugerencias([]); return; }
    const resultados = nomina.filter(e => e.nombre?.toLowerCase().includes(texto.toLowerCase()) && !asistentesForm.includes(e.nombre));
    setSugerencias(resultados.slice(0,5));
  };

  const agregarAsistenteForm = (nombre) => {
    if (!nombre.trim() || asistentesForm.includes(nombre)) return;
    setAsistentesForm(prev => [...prev, nombre]);
    setInputAsistente("");
    setSugerencias([]);
  };

  const quitarAsistenteForm = (nombre) => setAsistentesForm(prev => prev.filter(a => a !== nombre));

  const bg      = oscuro ? "#09184D" : Q.grisPalido;
  const cardBg  = oscuro ? "#0d2160" : Q.blanco;
  const texto   = oscuro ? "#EDF2FA" : Q.grisOscuro;
  const borde   = oscuro ? "#1e3a8a" : Q.grisClaro;
  const navBg   = oscuro ? "#060f30" : Q.azul;
  const subtexto= oscuro ? "#9aabd4" : Q.grisPlata;
  const esAdmin = usuario?.rol === "Administrador";
  if (cargandoCaps) return (
  <div style={{ minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", background:bg }}>
    <p style={{ color: oscuro?"white":Q.azul, fontSize:"16px" }}>Cargando capacitaciones...</p>
  </div>
);

  const inp = {width:"100%",padding:"9px 12px",borderRadius:"10px",border:`1.5px solid ${borde}`,fontSize:"13px",boxSizing:"border-box",marginTop:"4px",background:cardBg,color:texto,fontFamily:"sans-serif",outline:"none"};
  const lbl = {fontSize:"11px",color:subtexto,fontWeight:"700",display:"block",marginTop:"12px",letterSpacing:".05em",textTransform:"uppercase"};
  const card = {background:cardBg,borderRadius:"14px",padding:"1.5rem",border:`1px solid ${borde}`,marginBottom:"14px"};

  const guardar = () => {
    const nueva = {...form, id:Date.now(), codigo:generarCodCap(caps), asistentes:asistentesForm.map(n=>({id:Date.now()+Math.random(),nombre:n,fecha:new Date().toISOString()})), fechaCreacion:new Date().toISOString(), creadoPor:usuario?.nombre||"Sistema", rolCreador:usuario?.rol||""};
    const nuevas = [...caps, nueva];
    setCaps(nuevas);
    localStorage.setItem('alqos_caps', JSON.stringify(nuevas));
      subirDatos('alqos_caps');
    setForm({estado:"programada",tipo:"ISO 9001",modalidad:"Presencial",fecha:fechaHoy()});
    setAsistentesForm([]);
    setInputAsistente("");
    setVista("listado");
  };

  const eliminar = async (id) => {
    const nuevas = caps.filter(c=>c.id!==id);
    setCaps(nuevas);
    localStorage.setItem('alqos_caps', JSON.stringify(nuevas));
    await eliminarDato('alqos_caps', id);
    setConfirmEliminar(null); setDetalle(null); setVista("listado");
  };

  const cambiarEstado = (id, nuevoEstado) => {
    const act = caps.map(c=>c.id===id?{...c,estado:nuevoEstado}:c);
    setCaps(act);
    localStorage.setItem('alqos_caps', JSON.stringify(act));
    subirDatos('alqos_caps');
    if (detalle?.id===id) setDetalle(prev=>({...prev,estado:nuevoEstado}));
  };

  const agregarAsistente = () => {
    if (!nuevoAsistente.trim()) return;
    const asistente = {nombre:nuevoAsistente.trim(), id:Date.now(), fecha:new Date().toISOString()};
    const act = caps.map(c=>c.id===detalle.id?{...c,asistentes:[...(c.asistentes||[]),asistente]}:c);
    setCaps(act);
    localStorage.setItem('alqos_caps', JSON.stringify(act));
    subirDatos('alqos_caps');
    setDetalle(prev=>({...prev,asistentes:[...(prev.asistentes||[]),asistente]}));
    setNuevoAsistente("");
  };

  const eliminarAsistente = (asistenteId) => {
    const act = caps.map(c=>c.id===detalle.id?{...c,asistentes:c.asistentes.filter(a=>a.id!==asistenteId)}:c);
    setCaps(act);
    localStorage.setItem('alqos_caps', JSON.stringify(act));
    subirDatos('alqos_caps');
    setDetalle(prev=>({...prev,asistentes:prev.asistentes.filter(a=>a.id!==asistenteId)}));
  };

  // Capacitaciones con video
  const capsConVideo = caps.filter(c => c.videoUrl);
  const capsFiltradas = filtroEstado==="todos" ? caps : caps.filter(c=>c.estado===filtroEstado);
  const resumen = {
    total:caps.length,
    realizadas:caps.filter(c=>c.estado==="realizada").length,
    programadas:caps.filter(c=>c.estado==="programada").length,
    totalAsistentes:caps.reduce((acc,c)=>acc+(c.asistentes?.length||0),0),
    conVideo:capsConVideo.length,
  };

  const Header = ({titulo,onBack,extra}) => (
    <div style={{background:navBg,padding:"1rem 1.5rem",display:"flex",alignItems:"center",justifyContent:"space-between",position:"sticky",top:0,zIndex:100,marginBottom:"1.5rem",boxShadow:`0 2px 12px ${Q.azul}40`}}>
      <div style={{display:"flex",alignItems:"center",gap:"12px"}}>
        <button onClick={onBack} style={{background:"rgba(255,255,255,0.1)",border:"none",color:"white",padding:"6px 14px",borderRadius:"10px",cursor:"pointer",fontSize:"13px"}}>← Volver</button>
        <span style={{color:"white",fontWeight:"700",fontSize:"16px"}}>{titulo}</span>
      </div>
      {extra}
    </div>
  );

  // ── CONFIRM ELIMINAR ──
  if (confirmEliminar) return (
    <div style={{minHeight:"100vh",background:bg,fontFamily:"sans-serif",display:"flex",alignItems:"center",justifyContent:"center"}}>
      <div style={{background:cardBg,borderRadius:"16px",padding:"2rem",maxWidth:"360px",width:"90%",border:`1px solid ${borde}`,textAlign:"center"}}>
        <p style={{fontSize:"36px",marginBottom:"1rem"}}>🎓</p>
        <p style={{fontSize:"15px",fontWeight:"600",color:texto,marginBottom:".5rem"}}>¿Eliminar esta capacitación?</p>
        <p style={{fontSize:"13px",color:subtexto,marginBottom:"1.5rem"}}>Se eliminarán también los asistentes registrados.</p>
        <div style={{display:"flex",gap:"10px",justifyContent:"center"}}>
          <button onClick={() => setConfirmEliminar(null)} style={{padding:"10px 20px",background:"none",border:`1px solid ${borde}`,borderRadius:"10px",cursor:"pointer",color:texto,fontSize:"13px"}}>Cancelar</button>
          <button onClick={() => eliminar(confirmEliminar)} style={{padding:"10px 20px",background:"#e63946",border:"none",borderRadius:"10px",cursor:"pointer",color:"white",fontSize:"13px",fontWeight:"600"}}>Eliminar</button>
        </div>
      </div>
    </div>
  );

  // ── VIDEOTECA ──
  if (vistaVideos) return (
    <div style={{minHeight:"100vh",background:bg,fontFamily:"sans-serif"}}>
      <Header titulo="📹 Videoteca de Capacitaciones" onBack={() => { setVistaVideos(false); setVideoActivo(null); }}/>
      <div style={{padding:"0 2rem 2rem",maxWidth:"800px",margin:"0 auto"}}>

        {videoActivo ? (
          <div>
            <button onClick={() => setVideoActivo(null)} style={{marginBottom:"1rem",padding:"6px 14px",background:"none",border:`1px solid ${borde}`,borderRadius:"8px",cursor:"pointer",color:texto,fontSize:"13px"}}>← Volver a videoteca</button>
            <div style={{...card, padding:"0", overflow:"hidden"}}>
              <PlayerVideo url={videoActivo.videoUrl}/>
            </div>
            <div style={card}>
              <h3 style={{fontSize:"15px",fontWeight:"700",color:Q.azul,marginBottom:"6px"}}>{videoActivo.titulo || videoActivo.tipo}</h3>
              <p style={{fontSize:"12px",color:subtexto,margin:"0 0 8px"}}>{videoActivo.tipo} · {videoActivo.modalidad} · {videoActivo.fecha}</p>
              {videoActivo.objetivo && <p style={{fontSize:"13px",color:texto,lineHeight:"1.6",margin:0}}>{videoActivo.objetivo}</p>}
            </div>
          </div>
        ) : (
          <>
            {capsConVideo.length === 0 ? (
              <div style={{textAlign:"center",padding:"4rem"}}>
                <p style={{fontSize:"48px"}}>📹</p>
                <p style={{fontSize:"15px",color:texto,fontWeight:"600",marginTop:"1rem"}}>No hay capacitaciones con video todavía</p>
                <p style={{fontSize:"13px",color:subtexto,marginTop:"6px"}}>Al crear una capacitación, podés agregar una URL de YouTube o Vimeo para que aparezca aquí.</p>
              </div>
            ) : (
              <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(320px,1fr))",gap:"14px"}}>
                {capsConVideo.map(c => {
                  const vid = extraerVideoId(c.videoUrl);
                  const thumb = vid?.tipo==="youtube" ? `https://img.youtube.com/vi/${vid.id}/mqdefault.jpg` : null;
                  return (
                    <div key={c.id} onClick={() => setVideoActivo(c)}
                      style={{background:cardBg,borderRadius:"14px",overflow:"hidden",border:`1px solid ${borde}`,cursor:"pointer",transition:"box-shadow 0.15s"}}
                      onMouseEnter={e=>e.currentTarget.style.boxShadow=`0 6px 24px ${Q.azulVivo}25`}
                      onMouseLeave={e=>e.currentTarget.style.boxShadow="none"}>
                      {/* Thumbnail */}
                      <div style={{position:"relative",height:"180px",background:`linear-gradient(135deg,${Q.azul},${Q.navOscuro})`,display:"flex",alignItems:"center",justifyContent:"center",overflow:"hidden"}}>
                        {thumb ? (
                          <img src={thumb} alt={c.titulo} style={{width:"100%",height:"100%",objectFit:"cover",opacity:0.85}}/>
                        ) : (
                          <span style={{fontSize:"48px"}}>▶</span>
                        )}
                        <div style={{position:"absolute",inset:0,background:"rgba(0,0,0,0.25)",display:"flex",alignItems:"center",justifyContent:"center"}}>
                          <div style={{width:"52px",height:"52px",borderRadius:"50%",background:"rgba(255,255,255,0.9)",display:"flex",alignItems:"center",justifyContent:"center",boxShadow:"0 4px 16px rgba(0,0,0,0.3)"}}>
                            <span style={{fontSize:"20px",marginLeft:"4px"}}>▶</span>
                          </div>
                        </div>
                        <div style={{position:"absolute",top:"8px",right:"8px",background:estadosCap[c.estado]?.color||"#808085",borderRadius:"8px",padding:"2px 8px"}}>
                          <span style={{fontSize:"10px",fontWeight:"700",color:"white"}}>{estadosCap[c.estado]?.label||c.estado}</span>
                        </div>
                      </div>
                      <div style={{padding:"1rem"}}>
                        <p style={{fontSize:"13px",fontWeight:"700",color:texto,margin:"0 0 4px"}}>{c.titulo||c.tipo}</p>
                        <p style={{fontSize:"11px",color:subtexto,margin:"0 0 4px"}}>{c.tipo} · {c.fecha}</p>
                        <p style={{fontSize:"11px",color:Q.azulVivo,fontWeight:"600",margin:0}}>{c.asistentes?.length||0} asistentes</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );

  // ── DETALLE ──
  if (vista==="detalle" && detalle) return (
    <div style={{minHeight:"100vh",background:bg,fontFamily:"sans-serif"}}>
      <Header titulo={detalle.codigo}
        onBack={() => {setDetalle(null); setVista("listado");}}
        extra={esAdmin && <button onClick={() => setConfirmEliminar(detalle.id)} style={{background:"rgba(230,57,70,.2)",border:"1px solid rgba(230,57,70,.4)",color:"#e63946",padding:"6px 14px",borderRadius:"10px",cursor:"pointer",fontSize:"12px"}}>🗑 Eliminar</button>}
      />
      <div style={{padding:"0 2rem 2rem",maxWidth:"700px",margin:"0 auto"}}>

        {/* Info */}
        <div style={{...card,background: oscuro?"#0a1f5c":"#eff6ff",border:`1px solid ${Q.azulVivo}30`}}>
          <h3 style={{fontSize:"13px",fontWeight:"700",color:Q.azulVivo,marginBottom:"12px",letterSpacing:".05em",textTransform:"uppercase"}}>Información general</h3>
          {[["Código",detalle.codigo],["Tipo",detalle.tipo],["Modalidad",detalle.modalidad],["Instructor",detalle.instructor],["Fecha",detalle.fecha],["Duración",detalle.duracion],["Lugar",detalle.lugar],["Creado por",`${detalle.creadoPor} — ${detalle.rolCreador}`]].map(([k,v])=>v&&(
            <div key={k} style={{display:"flex",justifyContent:"space-between",fontSize:"13px",padding:"5px 0",borderBottom:`0.5px solid ${borde}`}}>
              <span style={{color:subtexto}}>{k}</span>
              <span style={{color:texto,fontWeight:"500",maxWidth:"60%",textAlign:"right"}}>{v}</span>
            </div>
          ))}
        </div>

        {/* VIDEO */}
        {detalle.videoUrl && (
          <div style={card}>
            <h3 style={{fontSize:"13px",fontWeight:"700",color:Q.azul,marginBottom:"12px",letterSpacing:".05em",textTransform:"uppercase"}}>📹 Video de capacitación</h3>
            <PlayerVideo url={detalle.videoUrl}/>
            <p style={{fontSize:"11px",color:subtexto,marginTop:"8px",textAlign:"center"}}>Podés reproducir el video directamente desde ALQOS™</p>
          </div>
        )}

        {/* Estado */}
        <div style={card}>
          <h3 style={{fontSize:"13px",fontWeight:"700",color:Q.azul,marginBottom:"12px",letterSpacing:".05em",textTransform:"uppercase"}}>Estado</h3>
          <div style={{display:"flex",gap:"8px",flexWrap:"wrap"}}>
            {Object.entries(estadosCap).map(([val,{label,color}])=>(
              <button key={val} onClick={() => esAdmin&&cambiarEstado(detalle.id,val)}
                style={{padding:"7px 12px",borderRadius:"10px",fontSize:"12px",cursor:esAdmin?"pointer":"default",fontWeight:"600",border:detalle.estado===val?`2px solid ${color}`:`1px solid ${borde}`,background:detalle.estado===val?`${color}22`:cardBg,color:detalle.estado===val?color:subtexto}}>
                {label}
              </button>
            ))}
          </div>
        </div>

        {detalle.objetivo && <div style={card}><h3 style={{fontSize:"13px",fontWeight:"700",color:Q.azul,marginBottom:"8px"}}>Objetivo</h3><p style={{fontSize:"13px",color:texto,lineHeight:"1.6",margin:0}}>{detalle.objetivo}</p></div>}
        {detalle.contenido && <div style={card}><h3 style={{fontSize:"13px",fontWeight:"700",color:Q.azul,marginBottom:"8px"}}>Contenido</h3><p style={{fontSize:"13px",color:texto,lineHeight:"1.6",margin:0}}>{detalle.contenido}</p></div>}
        {detalle.observaciones && <div style={card}><h3 style={{fontSize:"13px",fontWeight:"700",color:Q.azul,marginBottom:"8px"}}>Observaciones</h3><p style={{fontSize:"13px",color:texto,lineHeight:"1.6",margin:0}}>{detalle.observaciones}</p></div>}

        {/* Asistentes */}
        <div style={card}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"12px"}}>
            <h3 style={{fontSize:"13px",fontWeight:"700",color:Q.azul,margin:0}}>Asistentes ({detalle.asistentes?.length||0})</h3>
          </div>
          {esAdmin && (
            <div style={{display:"flex",gap:"8px",marginBottom:"12px"}}>
              <input value={nuevoAsistente} onChange={e=>setNuevoAsistente(e.target.value)} onKeyDown={e=>e.key==="Enter"&&agregarAsistente()} style={{...inp,marginTop:0,flex:1}} placeholder="Nombre y apellido del asistente"/>
              <button onClick={agregarAsistente} style={{padding:"8px 14px",background:Q.azulVivo,color:"white",border:"none",borderRadius:"8px",cursor:"pointer",fontSize:"13px",fontWeight:"600"}}>+ Agregar</button>
            </div>
          )}
          {(detalle.asistentes||[]).length===0
            ? <p style={{fontSize:"13px",color:subtexto,textAlign:"center",padding:"1rem 0"}}>Sin asistentes registrados</p>
            : (detalle.asistentes||[]).map(a=>(
                <div key={a.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 12px",background: oscuro?"#091840":Q.grisPalido,borderRadius:"8px",marginBottom:"6px",border:`1px solid ${borde}`}}>
                  <span style={{fontSize:"13px",color:texto}}>👤 {a.nombre}</span>
                  {esAdmin && <button onClick={() => eliminarAsistente(a.id)} style={{background:"none",border:"none",color:"#e63946",cursor:"pointer",fontSize:"16px",fontWeight:"700"}}>×</button>}
                </div>
              ))
          }
        </div>
      </div>
    </div>
  );

  // ── NUEVA CAPACITACIÓN ──
  if (vista==="nueva") return (
    <div style={{minHeight:"100vh",background:bg,fontFamily:"sans-serif"}}>
      <Header titulo="Nueva Capacitación" onBack={() => setVista("listado")}/>
      <div style={{padding:"0 2rem 2rem",maxWidth:"700px",margin:"0 auto"}}>
        <div style={{...card,background: oscuro?"#0a1f5c":"#eff6ff",border:`1px solid ${Q.azulVivo}30`}}>
          <p style={{fontSize:"12px",color:subtexto,margin:0}}><strong style={{color:texto}}>Creado por:</strong> {usuario?.nombre} — {usuario?.rol}</p>
        </div>

        <div style={card}>
          <h3 style={{fontSize:"14px",fontWeight:"700",marginBottom:"12px",color:Q.azul}}>Datos de la capacitación</h3>

          <span style={lbl}>Tipo de capacitación</span>
          <select onChange={e=>setForm(f=>({...f,tipo:e.target.value}))} style={inp} defaultValue="ISO 9001">
            {tiposCap.map(t=><option key={t} value={t}>{t}</option>)}
          </select>

          <span style={lbl}>Modalidad</span>
          <select onChange={e=>setForm(f=>({...f,modalidad:e.target.value}))} style={inp} defaultValue="Presencial">
            {modalidades.map(m=><option key={m} value={m}>{m}</option>)}
          </select>

          <span style={lbl}>Estado</span>
          <div style={{display:"flex",gap:"8px",marginTop:"6px",flexWrap:"wrap"}}>
            {Object.entries(estadosCap).map(([val,{label,color}])=>(
              <button key={val} onClick={() => setForm(f=>({...f,estado:val}))}
                style={{padding:"7px 12px",borderRadius:"10px",fontSize:"12px",cursor:"pointer",fontWeight:"600",border:form.estado===val?`2px solid ${color}`:`1px solid ${borde}`,background:form.estado===val?`${color}22`:cardBg,color:form.estado===val?color:texto}}>
                {label}
              </button>
            ))}
          </div>

          {[
            {key:"titulo",    label:"Título de la capacitación"},
            {key:"instructor",label:"Instructor / Capacitador"},
            {key:"fecha",     label:"Fecha",type:"date"},
            {key:"duracion",  label:"Duración (ej: 2hs, 1 día)"},
            {key:"lugar",     label:"Lugar / Plataforma"},
            {key:"objetivo",  label:"Objetivo",multiline:true},
            {key:"contenido", label:"Contenido / Temario",multiline:true},
            {key:"observaciones",label:"Observaciones",multiline:true},
          ].map(({key,label,type,multiline})=>(
            <div key={key}>
              <span style={lbl}>{label}</span>
              {multiline
                ? <textarea rows={3} onChange={e=>setForm(f=>({...f,[key]:e.target.value}))} style={{...inp,resize:"none"}}/>
                : <input type={type||"text"} defaultValue={key==="fecha"?fechaHoy():""} onChange={e=>setForm(f=>({...f,[key]:e.target.value}))} style={inp}/>
              }
            </div>
          ))}
        </div>

        {/* VIDEO URL */}
        <div style={{...card,background: oscuro?"#0a1f5c":"#f0fdf4",border:`1px solid #22c55e30`}}>
          <h3 style={{fontSize:"14px",fontWeight:"700",color:"#16a34a",marginBottom:"6px"}}>📹 Video de capacitación (opcional)</h3>
          <p style={{fontSize:"12px",color:subtexto,marginBottom:"12px"}}>Pegá una URL de YouTube o Vimeo. El video se reproducirá directamente dentro de ALQOS™.</p>
          <input placeholder="https://www.youtube.com/watch?v=... o https://vimeo.com/..."
            onChange={e=>setForm(f=>({...f,videoUrl:e.target.value}))} style={inp}/>
          {form.videoUrl && (
            <div style={{marginTop:"12px"}}>
              <p style={{fontSize:"11px",color:subtexto,marginBottom:"8px"}}>Vista previa:</p>
              <PlayerVideo url={form.videoUrl}/>
            </div>
          )}
        </div>

        {/* PARTICIPANTES */}
        <div style={{...card, background:oscuro?"#0a1f5c":"#f5f3ff", border:`1px solid #7B5BF230`}}>
          <h3 style={{fontSize:"14px",fontWeight:"700",color:"#7B5BF2",marginBottom:"6px"}}>👥 Participantes</h3>
          <p style={{fontSize:"12px",color:subtexto,marginBottom:"12px"}}>Buscá por nombre o agregá manualmente. Podés agregar todos los que quieras.</p>
          <div style={{position:"relative"}}>
            <div style={{display:"flex",gap:"8px"}}>
              <input
                value={inputAsistente}
                onChange={e=>{ setInputAsistente(e.target.value); buscarSugerencias(e.target.value); }}
                onKeyDown={e=>{ if(e.key==="Enter"){ e.preventDefault(); agregarAsistenteForm(inputAsistente); } }}
                placeholder="Buscá por nombre o escribí uno nuevo..."
                style={{...inp,marginTop:0,flex:1}}
              />
              <button onClick={()=>agregarAsistenteForm(inputAsistente)}
                style={{padding:"8px 16px",background:"#7B5BF2",color:"white",border:"none",borderRadius:"10px",cursor:"pointer",fontWeight:"700",fontSize:"13px",flexShrink:0}}>
                + Agregar
              </button>
            </div>
            {sugerencias.length>0&&(
              <div style={{position:"absolute",top:"100%",left:0,right:"80px",background:cardBg,border:`1px solid ${borde}`,borderRadius:"10px",zIndex:50,boxShadow:"0 4px 20px rgba(0,0,0,0.15)",marginTop:"4px"}}>
                {sugerencias.map(e=>(
                  <div key={e.id} onClick={()=>agregarAsistenteForm(e.nombre)}
                    style={{padding:"8px 12px",cursor:"pointer",fontSize:"13px",borderBottom:`0.5px solid ${borde}`}}
                    onMouseEnter={ev=>ev.currentTarget.style.background=oscuro?"#0a1f5c":"#f0eeff"}
                    onMouseLeave={ev=>ev.currentTarget.style.background="transparent"}>
                    <span style={{fontWeight:"600",color:"#7B5BF2"}}>{e.nombre}</span>
                    <span style={{fontSize:"11px",color:subtexto,marginLeft:"8px"}}>{e.puesto} · {e.area}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
          {asistentesForm.length>0&&(
            <div style={{marginTop:"12px",display:"flex",flexWrap:"wrap",gap:"6px"}}>
              {asistentesForm.map(nombre=>(
                <div key={nombre} style={{display:"flex",alignItems:"center",gap:"6px",background:oscuro?"#1a1060":"#ede9fe",border:"1px solid #7B5BF230",borderRadius:"20px",padding:"4px 10px"}}>
                  <span style={{fontSize:"12px",color:oscuro?"#c4b5fd":"#5b21b6",fontWeight:"600"}}>👤 {nombre}</span>
                  <button onClick={()=>quitarAsistenteForm(nombre)} style={{background:"none",border:"none",cursor:"pointer",color:"#e63946",fontSize:"14px",lineHeight:1}}>×</button>
                </div>
              ))}
            </div>
          )}
          {asistentesForm.length===0&&<p style={{fontSize:"12px",color:subtexto,marginTop:"8px"}}>Sin participantes aún</p>}
        </div>

        <button onClick={guardar} style={{width:"100%",padding:"15px",background:`linear-gradient(135deg,${Q.azulVivo},${Q.azul})`,color:"white",border:"none",borderRadius:"12px",fontSize:"15px",fontWeight:"700",cursor:"pointer",marginTop:"0.5rem",boxShadow:`0 4px 20px ${Q.azulVivo}40`}}>
          💾 Guardar Capacitación
        </button>
      </div>
    </div>
  );

  // ── LISTADO PRINCIPAL ──
  return (
    <div style={{minHeight:"100vh",background:bg,fontFamily:"sans-serif"}}>
      <div style={{background:navBg,padding:"1rem 1.5rem",display:"flex",alignItems:"center",justifyContent:"space-between",position:"sticky",top:0,zIndex:100,boxShadow:`0 2px 12px ${Q.azul}40`}}>
        <div style={{display:"flex",alignItems:"center",gap:"12px"}}>
          <button onClick={onVolver} style={{background:"rgba(255,255,255,0.1)",border:"none",color:"white",padding:"6px 14px",borderRadius:"10px",cursor:"pointer",fontSize:"13px"}}>← Menú</button>
          <BotonInstructivo moduloKey="capacitaciones" oscuro={oscuro} />
          {usuario?.rol === "Administrador" && <BotonMapaProceso moduloKey="capacitaciones" oscuro={oscuro} />}
          <span style={{color:"white",fontWeight:"700",fontSize:"16px"}}>🎓 Capacitaciones</span>
        </div>
        <div style={{display:"flex",gap:"8px"}}>
          {capsConVideo.length > 0 && (
            <button onClick={() => setVistaVideos(true)}
              style={{padding:"6px 12px",background:"rgba(255,255,255,0.12)",border:"1px solid rgba(255,255,255,0.2)",color:"white",borderRadius:"8px",cursor:"pointer",fontSize:"12px",fontWeight:"600"}}>
              📹 Videoteca ({capsConVideo.length})
            </button>
          )}
          <CampanaNotificaciones oscuro={oscuro} modulo="Capacitaciones" />
          {esAdmin && (
            <button onClick={() => setVista("nueva")}
              style={{padding:"6px 14px",background:Q.azulVivo,color:"white",border:"none",borderRadius:"8px",cursor:"pointer",fontSize:"13px",fontWeight:"600"}}>
              + Nueva
            </button>
          )}
        </div>
      </div>

      <div style={{padding:"1.2rem 1.5rem"}}>
        {/* KPIs */}
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(130px,1fr))",gap:"10px",marginBottom:"1.5rem"}}>
          {[["Total",resumen.total,Q.azulVivo],["Realizadas",resumen.realizadas,"#22c55e"],["Programadas",resumen.programadas,"#3b82f6"],["Asistentes",resumen.totalAsistentes,"#f59e0b"],["Con video",resumen.conVideo,"#16a34a"]].map(([lab,val,col])=>(
            <div key={lab} style={{background:cardBg,borderRadius:"14px",padding:"1rem",border:`1px solid ${borde}`,textAlign:"center",boxShadow:`0 2px 8px ${col}15`}}>
              <p style={{fontSize:"22px",fontWeight:"800",color:col,margin:0}}>{val}</p>
              <p style={{fontSize:"11px",color:subtexto,margin:"4px 0 0",fontWeight:"600"}}>{lab}</p>
            </div>
          ))}
        </div>

        {/* Videoteca promo si hay videos */}
        {capsConVideo.length > 0 && (
          <div onClick={() => setVistaVideos(true)}
            style={{background: oscuro?"#0a1f3c":"#f0fdf4",borderRadius:"14px",padding:"1rem 1.5rem",border:`1.5px solid #22c55e30`,marginBottom:"1.2rem",cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center"}}
            onMouseEnter={e=>e.currentTarget.style.boxShadow=`0 4px 16px #22c55e25`}
            onMouseLeave={e=>e.currentTarget.style.boxShadow="none"}>
            <div>
              <p style={{fontSize:"13px",fontWeight:"700",color:"#16a34a",margin:"0 0 2px"}}>📹 Videoteca disponible</p>
              <p style={{fontSize:"12px",color:subtexto,margin:0}}>{capsConVideo.length} capacitación{capsConVideo.length!==1?"es":""} con video para reproducir</p>
            </div>
            <span style={{color:"#16a34a",fontSize:"18px"}}>→</span>
          </div>
        )}

        {/* Filtros */}
        <div style={{display:"flex",gap:"6px",flexWrap:"wrap",marginBottom:"1.2rem"}}>
          <button onClick={() => setFiltroEstado("todos")} style={{padding:"4px 12px",borderRadius:"16px",fontSize:"11px",cursor:"pointer",fontWeight:"700",border:filtroEstado==="todos"?`2px solid ${Q.azulVivo}`:`1px solid ${borde}`,background:filtroEstado==="todos"?`${Q.azulVivo}15`:cardBg,color:filtroEstado==="todos"?Q.azulVivo:subtexto}}>Todas</button>
          {Object.entries(estadosCap).map(([val,{label,color}])=>(
            <button key={val} onClick={() => setFiltroEstado(val)} style={{padding:"4px 12px",borderRadius:"16px",fontSize:"11px",cursor:"pointer",fontWeight:"700",border:filtroEstado===val?`2px solid ${color}`:`1px solid ${borde}`,background:filtroEstado===val?`${color}22`:cardBg,color:filtroEstado===val?color:subtexto}}>{label}</button>
          ))}
        </div>

        {/* Lista */}
        {capsFiltradas.length===0
          ? <div style={{textAlign:"center",padding:"5rem 2rem"}}>
              <p style={{fontSize:"48px"}}>🎓</p>
              <p style={{fontSize:"15px",color:texto,fontWeight:"600",marginTop:"1rem"}}>No hay capacitaciones registradas</p>
              {esAdmin && <p style={{fontSize:"13px",color:subtexto}}>Tocá "+ Nueva" para registrar la primera.</p>}
            </div>
          : capsFiltradas.map(c=>(
              <div key={c.id} onClick={() => {setDetalle(c); setVista("detalle");}}
                style={{background:cardBg,borderRadius:"14px",padding:"1.2rem 1.5rem",border:`1.5px solid ${borde}`,marginBottom:"10px",cursor:"pointer",transition:"box-shadow 0.15s"}}
                onMouseEnter={e=>e.currentTarget.style.boxShadow=`0 4px 20px ${Q.azulVivo}20`}
                onMouseLeave={e=>e.currentTarget.style.boxShadow="none"}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                  <div style={{flex:1}}>
                    <div style={{display:"flex",alignItems:"center",gap:"8px",flexWrap:"wrap"}}>
                      <span style={{fontWeight:"700",color:Q.azulVivo,fontSize:"13px"}}>{c.codigo}</span>
                      <span style={{fontSize:"13px",color:texto,fontWeight:"600"}}>{c.titulo||c.tipo}</span>
                      {c.videoUrl && <span style={{fontSize:"10px",fontWeight:"700",color:"#16a34a",background:"#f0fdf4",padding:"1px 7px",borderRadius:"6px"}}>📹 Con video</span>}
                    </div>
                    <p style={{fontSize:"12px",color:subtexto,margin:"4px 0 0"}}>{c.tipo} · {c.modalidad} · {c.asistentes?.length||0} asistentes</p>
                  </div>
                  <div style={{display:"flex",flexDirection:"column",alignItems:"flex-end",gap:"4px",flexShrink:0}}>
                    <span style={{fontSize:"11px",fontWeight:"700",color:estadosCap[c.estado]?.color}}>{estadosCap[c.estado]?.label}</span>
                    <span style={{fontSize:"11px",color:subtexto}}>{c.fecha}</span>
                  </div>
                </div>
                <div style={{marginTop:"6px",fontSize:"11px",color: oscuro?Q.azulMedio:Q.grisPlata}}>
                  Instructor: {c.instructor||"—"} · Por {c.creadoPor}
                </div>
              </div>
            ))
        }
      </div>
    </div>
  );
}